import React, { useMemo } from 'react';
import { useDispatch, batch } from 'react-redux';

import { Box } from '@missionlabs/smartagent-app-components';

import useMonitoring from 'hooks/redux/useMonitoring';
import useMetrics from 'hooks/redux/useMetrics';

import { sortConnections } from 'views/Home/Monitoring/utils';

import Controls from 'views/Home/Monitoring/Controls';
import ParticipantList from 'views/Home/Monitoring/ParticipantList';

import { leaveCall, updateMonitorStatus } from 'store/call/call.actions';
import { monitorAgent } from 'store/metrics/metrics.actions';

import type { CallConnection } from 'store/call/call.state';

export type Props = {
    connections: CallConnection[];
};

const Monitoring: React.FC<Props> = ({ connections }) => {
    const dispatch = useDispatch();

    const { monitoringAgent } = useMetrics();
    const { isBarging } = useMonitoring();

    const onMonitor = () => {
        dispatch(updateMonitorStatus('SILENT_MONITOR'));
    };

    const onBarge = () => {
        dispatch(updateMonitorStatus('BARGE'));
    };

    const onLeave = () => {
        batch(() => {
            dispatch(monitorAgent(monitoringAgent?.agentID, false));
            dispatch(leaveCall());
        });
    };

    const sortedConnections = useMemo(() => sortConnections(connections), [connections]);

    return (
        <Box aria-labelledby="monitor-call-header" header={<h3 id="monitor-call-header">Monitor Call</h3>}>
            <ParticipantList connections={sortedConnections} />
            <Controls isBarging={isBarging} onBarge={onBarge} onMonitor={onMonitor} onLeave={onLeave} />
        </Box>
    );
};

export default Monitoring;
